<template>
  <button
    type="button"
    class="sk-modal-action-button"
    :class="variantClass"
    :style="{ width, height }"
    :disabled="disabled"
    v-bind="$attrs"
   data-testid="components-ui-new-sk-modal-action-button-button">
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    validator: (value: string) =>
      ['primary', 'cancel', 'danger'].includes(value)
  },
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '30px'
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const variantClass = computed(() => ({
  'sk-modal-action-button--primary': props.variant === 'primary',
  'sk-modal-action-button--cancel': props.variant === 'cancel',
  'sk-modal-action-button--danger': props.variant === 'danger'
}));
</script>

<style lang="scss" scoped>
.sk-modal-action-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  width: v-bind(width);
  min-width: auto;
  height: v-bind(height);
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  white-space: nowrap;
  border-radius: 8px;
  outline: none;
  transition: 0.2s;
  cursor: pointer;
  font-weight: 600;
  box-sizing: border-box;
}

.sk-modal-action-button--primary {
  color: #ffffff;
  background: #3A7CCA;

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }
}

.sk-modal-action-button--cancel {
  color: #00000099;
  background: #0000001A;

  &:hover:not(:disabled) {
    background: #0000000D;
  }
}

.sk-modal-action-button--danger {
  color: #fff;
  background: #FA6E6E;

  &:hover:not(:disabled) {
    background: #f68080;
  }
}

.sk-modal-action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
</style>

